import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Sticky from 'react-stickynode';

// Images
import logo from '../../images/logo.png';
import logoWhite from '../../images/logo-white.png';
// import iconIdiom from '../../images/mexico.png';

class Header extends Component{
	
	componentDidMount() {
		
 
 
		// Mobile Menu Open
		var menuIcon = document.querySelector(".menuicon")
		var menuLinks = document.querySelector(".menu-links")
		var menuClose = document.getElementById("menuClose")

		menuIcon.addEventListener('click',function(){
			menuLinks.classList.add("show")
		})

		menuClose.addEventListener('click',function(){
			menuLinks.classList.remove("show")
		})
		
		// Mobile Submenu open close function
        var navMenu = [].slice.call(document.querySelectorAll('.menu-links > ul > li'));
        for (var y = 0; y < navMenu.length; y++) {
            navMenu[y].addEventListener('click', function () { menuClick(this) });
        }

        function menuClick(current) {
            const active = current.classList.contains("open")
            navMenu.forEach(el => el.classList.remove('open'));
            
            if(active){
                current.classList.remove('open') 
                console.log("active")
            } else{
                current.classList.add('open');
                console.log("close")
            }
        }
    }
	
	render(){
		return(
			<>
				<header className="header header-transparent rs-nav">
					<Sticky enabled={true} className="sticky-header navbar-expand-lg">
						<div className="menu-bar clearfix">
							<div className="container-fluid clearfix">
								<div className="menu-logo logo-dark">
									<Link to="/"><img src={logo} alt=""/></Link>
								</div>
								<button className="navbar-toggler collapsed menuicon justify-content-end" type="button" data-bs-toggle="collapse" data-bs-target="#menuDropdown" aria-controls="menuDropdown" aria-expanded="false" aria-label="Toggle navigation">
									<span></span>
									<span></span>
									<span></span>
								</button>
								<div className="secondary-menu">
									<ul>
										{/* <li className="search-btn"><img src={iconIdiom} alt=""/></li> */}
										
										<li className="num-bx"><a href="tel:4491647579"><i className="fas fa-phone-alt"></i> (+52) 449 164 7579</a></li>
										<li className="btn-area"><a href="/citas" className="btn btn-primary shadow">AGENDAR CITA<i className="btn-icon-bx fas fa-chevron-right"></i></a></li>
									</ul>
								</div>
								<div className="menu-links navbar-collapse collapse justify-content-end" id="menuDropdown">
									<div className="menu-logo">
										<Link to="/"><img src={logoWhite} alt=""/></Link>
									</div>
									<ul className="nav navbar-nav">	
										<li className="active"><Link to="/">Inicio</Link></li>
										<li>
											<Link to="#">Servicios <i className="fas fa-plus"></i></Link>
											<ul className="sub-menu">
												<li className="add-menu-left">
													<ul>
														<li><Link to="/citas"><span>Citas</span></Link></li>
														<li><Link to="/service_ct"><span>Enfermedades Digestivas Quirúrgicas</span></Link></li>
														<li><Link to="/service_e"><span>Enfermedades Digestivas Médicas</span></Link></li>
														<li><Link to="/service_t"><span>Tratamiento Médico</span></Link></li>
													</ul>
												</li>
											</ul>
										</li>
										<li>
											<Link to="/cobertura">Cobertura </Link>
											 
										</li>
										<li><Link to="#">Padecimientos <i className="fas fa-plus"></i></Link>
											<ul className="sub-menu left">
												<li><Link to="/service_ct"><span>Colecistectomía Laparoscópica</span></Link></li>
												<li><Link to="/service_erge"><span>Funduplicatura</span></Link></li>
											</ul>
										</li>
										<li><Link to="/contact-us">Contacto</Link></li>
										<li><Link to="/cofepris">COFEPRIS</Link></li>
									</ul>
									<ul className="social-media">
										<li><a target="_blank" rel="noreferrer" href="https://www.facebook.com/Gastrocirugiaags/" className="btn btn-primary"><i className="fab fa-facebook-f"></i></a></li>
										<li><a target="_blank" rel="noreferrer" href="https://www.doctoralia.com.mx/eduardo-alvarez-del-castillo-sanchez/cirujano-general/aguascalientes" className="btn btn-primary"><i className="fas fa-briefcase-medical"></i></a></li>
										<li><a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/eduardo-javier-%C3%A1lvarez-del-castillo-s%C3%A1nchez-915288247/" className="btn btn-primary"><i className="fab fa-linkedin-in"></i></a></li>
										<li><a target="_blank" rel="noreferrer" href="https://agsmedico.com/cirugia-general/alvarezdelcastillo" className="btn btn-primary"><i className="fas fa-user-md"></i></a></li>
									</ul>
									<div className="menu-close" id="menuClose">
										<i className="ti-close"></i>
									</div>
								</div>
							</div>
						</div>
					</Sticky>
 
				</header>
				
			</>
		);
	}
}

export default Header;
